import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/app/app-shell";
import { OrganizationsManager } from "@/components/app/organizations-manager";

export const Route = createFileRoute("/_authenticated/organizations")({
  head: () => ({
    meta: [
      { title: "Organizations | Warrior Volunteer" },
      {
        name: "description",
        content: "Every organization in the outreach directory, its email domains, and its contacts.",
      },
      { property: "og:title", content: "Organizations | Warrior Volunteer" },
      {
        property: "og:description",
        content: "Every organization in the outreach directory, its email domains, and its contacts.",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: OrganizationsPage,
});

function OrganizationsPage() {
  return (
    <AppShell eyebrow="Inbox" title="Organizations">
      <OrganizationsManager scope="mine" />
    </AppShell>
  );
}
